import * as React from 'react';
import Layout from '../components/Utilities/Layout';
import { Box, Button, ButtonProps, Card, CardContent, FormControlLabel, Grid, IconButton, Stack, Switch, Typography } from '@mui/material';
import Common from '../utilities/common';
import $ from "jquery";
import SecurityTrimmer from '../components/Utilities/SecurityTrimmer';
import { Entity, PermissionLevel } from '../utilities/Permisos';
import EntitySettings from '../components/EntitySettings';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import TotalChart from '../Chart/TotalChart';
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined';
import ExtraccionesList from './ExtraccionesList';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import ExtraccionesClientesChart from './ExtraccionesClientesChart';
import ExtraccionesEstadosChart from './ExtraccionesEstadosChart';
import StopCircleOutlinedIcon from '@mui/icons-material/StopCircleOutlined';
import ExtraccionesPorCliente from './ExtraccionesPorCliente';
import ExtraccionesUltimoMesChart from './ExtraccionesUltimoMesChart';
import ExtraccionesDataComparerChart from './ExtraccionesDataComparerChart';
import { DataGrid, GridCsvExportOptions, GridCsvGetRowsToExportParams, gridExpandedSortedRowIdsSelector, GridRowSelectionModel, GridToolbarContainer, useGridApiContext } from '@mui/x-data-grid';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ReactInterval from 'react-interval';
import ExtraccionesVerticalesChart from './ExtraccionesVerticalesChart';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import PauseOutlinedIcon from '@mui/icons-material/PauseOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import OutputOutlinedIcon from '@mui/icons-material/OutputOutlined';
import DatosPorClienteChart from './DatosPorClienteChart';
import DatosPorVerticalChart from './DatosPorVerticalChart';
import FeatureManager from '../components/Utilities/FeatureManager';

export interface IExtraccionesState {
    data: any[];
    total: number;
    finalizadas: number;
    clientes: number;
    verticales: number;
    pendientes: number;
    totalData: number;
}

const getFilteredRows = ({ apiRef }: GridCsvGetRowsToExportParams) =>
    gridExpandedSortedRowIdsSelector(apiRef);

const ExportButton = () => {
    const apiRef = useGridApiContext();
  
    const handleExport = (options: GridCsvExportOptions) =>
      apiRef.current.exportDataAsCsv(options);
  
    const buttonBaseProps: ButtonProps = {
      color: 'primary',
      size: 'small',
      startIcon: <FileDownloadOutlinedIcon />,
    };
  
    return (
        <Button
            {...buttonBaseProps}
            onClick={() => handleExport({ getRowsToExport: getFilteredRows, fileName: 'comunidades_autonomas' })}
        >
            Exportar CSV
        </Button>
    );
}

export default class Extracciones extends React.Component<{}, IExtraccionesState> {
    public constructor(props: {}) {
        super(props);

        this.state = {
            data: [],
            total: 0,
            finalizadas: 0,
            clientes: 0,
            verticales: 0,
            pendientes: 0,
            totalData: 0
        };
    }

    componentDidMount(): void {
        this.Get();
        this.Gettotal();
        this.GetFinalizadas();
        this.GetPendientes();
        this.GetClientes();
        this.GetVerticales();
    }

    public render(): React.ReactElement<{}> {
        return (
            <FeatureManager entidad={Entity.Extracciones} operacion='Ver' showBuyOption>
                <SecurityTrimmer entity={Entity.Extracciones} permission={PermissionLevel.Ver} noAccessMessage='No tiene permisos para ver este contenido.'>
                    <ReactInterval timeout={3000} enabled={true} callback={() => {
                        this.Get();
                    }}/>
                    <Layout breadcrumb={
                        [
                            {
                                title: 'Inicio',
                                url: '/'
                            },
                            {
                                title: 'Extracciones',
                                url: ''
                            }
                        ]
                    }>
                        <Box className='stepper'>
                            <Grid container>
                                <Grid item xs={1}>
                                    <Typography>
                                        <ExitToAppOutlinedIcon className='mainIcon'/>
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <Typography className='mainTitle'>
                                    Extracciones
                                    </Typography>
                                </Grid>
                                <Grid item xs={2} className='entitySettings'>
                                    <EntitySettings entity={Entity.Extracciones}/>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box className='main transparent'>
                            <Grid container spacing={2}>
                                <Grid item xs={2}>
                                    <TotalChart title='Extracciones' total={this.state.total} icon={<StorageOutlinedIcon style={{fontSize: '42px', position: 'relative', top: '7px', opacity: '.5'}}/>}/>
                                </Grid>
                                <Grid item xs={2}>
                                    <TotalChart title='Clientes' total={this.state.clientes} icon={<HandshakeOutlinedIcon style={{fontSize: '42px', position: 'relative', top: '7px', opacity: '.5'}}/>}/>
                                </Grid>
                                <Grid item xs={2}>
                                    <TotalChart title='Verticales' total={this.state.verticales} icon={<StorefrontOutlinedIcon style={{fontSize: '42px', position: 'relative', top: '7px', opacity: '.5'}}/>}/>
                                </Grid>
                                <Grid item xs={2}>
                                    <TotalChart title='Finalizadas' total={this.state.finalizadas} icon={<StopCircleOutlinedIcon style={{fontSize: '42px', position: 'relative', top: '7px', opacity: '.5'}}/>}/>
                                </Grid>
                                <Grid item xs={2}>
                                    <TotalChart title='Pendientes' total={this.state.pendientes} icon={<PauseOutlinedIcon style={{fontSize: '42px', position: 'relative', top: '7px', opacity: '.5'}}/>}/>
                                </Grid>
                                <Grid item xs={2}>
                                    <TotalChart title='Datos extraídos' total={this.state.totalData} icon={<OutputOutlinedIcon style={{fontSize: '42px', position: 'relative', top: '7px', opacity: '.5'}}/>}/>
                                </Grid>
                                <Grid item xs={12}>
                                    <Card>
                                        <CardContent>
                                            <DataGrid
                                                autoHeight
                                                slots={{ toolbar: this.CustomToolbar.bind(this) }}
                                                rows={this.state.data}
                                                slotProps={{ pagination: { labelRowsPerPage: 'Filas por página' } }}
                                                columns={[
                                                    { 
                                                        field: 'id', 
                                                        headerName: '', 
                                                        width: 50,
                                                        renderCell: ({ row }) => (
                                                            this.RenderRowViewButton(row['id'])
                                                        )
                                                    },
                                                    { 
                                                        field: 'status', 
                                                        headerName: 'Estado', 
                                                        width: 100,
                                                        renderCell: ({ row }) => (
                                                            Common.RenderIconStatus(row, 'status')
                                                        )
                                                    },
                                                    { 
                                                        field: 'date', 
                                                        headerName: 'Fecha de solicitud', 
                                                        width: 150,
                                                        renderCell: ({ row }) => (
                                                            Common.RenderDate(row, 'date')
                                                        )
                                                    },
                                                    { 
                                                        field: 'startTime', 
                                                        headerName: 'Fecha de inicio', 
                                                        width: 150,
                                                        renderCell: ({ row }) => (
                                                            Common.RenderDate(row, 'startTime')
                                                        )
                                                    },
                                                    { 
                                                        field: 'endTime', 
                                                        headerName: 'Fecha de fin', 
                                                        width: 150,
                                                        renderCell: ({ row }) => (
                                                            Common.RenderDate(row, 'endTime')
                                                        )
                                                    },
                                                    { 
                                                        field: 'creadoPor', 
                                                        headerName: 'Creado por', 
                                                        width: 200,
                                                        renderCell: ({ row }) => (
                                                            Common.RenderUser(row, 'creadoPor')
                                                        )
                                                    },
                                                    { 
                                                        field: 'fallow', 
                                                        headerName: 'Barbecho', 
                                                        width: 100
                                                    },
                                                    { 
                                                        field: 'rows', 
                                                        headerName: 'Registros', 
                                                        width: 100
                                                    },
                                                    { 
                                                        field: 'type', 
                                                        headerName: 'Orden de registros', 
                                                        width: 200,
                                                        renderCell: ({ row }) => (
                                                            this.RenderType(row, 'type', row['rows'])
                                                        )
                                                    },
                                                    { 
                                                        field: 'fallowPriority', 
                                                        headerName: 'Prioridad de barbecho', 
                                                        width: 150,
                                                        renderCell: ({ row }) => (
                                                            this.RenderFallowPriority(row, 'fallowPriority')
                                                        )
                                                    }
                                                ]}
                                                initialState={{
                                                    pagination: {
                                                        paginationModel: { page: 0, pageSize: 30 },
                                                    },
                                                }}
                                                pageSizeOptions={[30, 60, 100]}
                                                hideFooter={this.state.data.length <= 30}
                                            />
                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid item xs={4}>
                                    <ExtraccionesUltimoMesChart/>
                                </Grid>
                                <Grid item xs={4}>
                                    <ExtraccionesClientesChart/>
                                </Grid>
                                <Grid item xs={4}>
                                    <ExtraccionesVerticalesChart/>
                                </Grid>
                                <Grid item xs={3}>
                                    <ExtraccionesDataComparerChart/> 
                                </Grid>
                                <Grid item xs={5}>
                                    <DatosPorClienteChart/> 
                                </Grid>
                                <Grid item xs={4}>
                                    <DatosPorVerticalChart/> 
                                </Grid>
                            </Grid>
                        </Box>
                    </Layout>
                </SecurityTrimmer>
            </FeatureManager>
        )
    }

    private Get(): void {
        let url = `${Common.END_POINT}/extracciones`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            console.log('extracciones', response);
            let total: number = 0;

            for(var i = 0; i < response.length; i++) {
                total += response[i].rows;
            }

            this.setState(
                {
                    data: response,
                    totalData: total
                }
            );
        }).fail((jqXHR: any, textStatus: any, errorThrown: any) => {
            if(jqXHR.status == 401) {
                window.location.href = "/login";
            }
        });
    }

    private Gettotal(): void {
        let url = `${Common.END_POINT}/extracciones/total`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    total: response[0].total
                }
            );
        }).fail((jqXHR: any, textStatus: any, errorThrown: any) => {
            if(jqXHR.status == 401) {
                window.location.href = "/login";
            }
        });
    }

    private GetFinalizadas(): void {
        let url = `${Common.END_POINT}/extracciones/status/finalizado`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    finalizadas: response[0].total
                }
            );
        }).fail((jqXHR: any, textStatus: any, errorThrown: any) => {
            if(jqXHR.status == 401) {
                window.location.href = "/login";
            }
        });
    }

    private GetPendientes(): void {
        let url = `${Common.END_POINT}/extracciones/status/pendiente`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    pendientes: response[0].total
                }
            );
        }).fail((jqXHR: any, textStatus: any, errorThrown: any) => {
            if(jqXHR.status == 401) {
                window.location.href = "/login";
            }
        });
    }

    private GetClientes(): void {
        let url = `${Common.END_POINT}/extracciones/clientes`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    clientes: response.length
                }
            );
        }).fail((jqXHR: any, textStatus: any, errorThrown: any) => {
            if(jqXHR.status == 401) {
                window.location.href = "/login";
            }
        });
    }

    private GetVerticales(): void {
        let url = `${Common.END_POINT}/extracciones/verticales`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    verticales: response.length
                }
            );
        }).fail((jqXHR: any, textStatus: any, errorThrown: any) => {
            if(jqXHR.status == 401) {
                window.location.href = "/login";
            }
        });
    }

    public RenderType(data: any, key: string, rows: number) {
        switch(data[key].toLowerCase()) {
            case 'first':
                return (
                    `${rows} primeros registros`
                );
            case 'last':
                return (
                    `${rows} últimos registros`
                );
            case 'random':
                return (
                    `Aleatorio`
                );
        }
    }

    public RenderFallowPriority(data: any, key: string) {
        switch(data[key].toLowerCase()) {
            case 'date':
                return (
                    `Por fecha`
                );
            case 'client':
                return (
                    `Primero cliente`
                );
            case 'vertical':
                return (
                    `Primero vertical`
                );
        }
    }

    public RenderRowViewButton(id: number) {
        return (
            <IconButton onClick={() => {
                window.location.href = '/extracciones/detalle?id=' + id;
            }}>
                <VisibilityIcon/>
            </IconButton>
        );
    }

    private CustomToolbar() {
        return (
            <Stack direction={'row'} alignItems={'center'} className='toolbar' gap={'20px'}>
                <FeatureManager entidad={Entity.Extracciones} operacion='Crear'>
                    <Button startIcon={<AddCircleOutlineOutlinedIcon />} size='small' variant='contained' onClick={() => {
                        window.location.href = '/extracciones/nueva';
                    }}>
                        Nueva extracción
                    </Button>
                </FeatureManager>
                <Button startIcon={<SearchOutlinedIcon />} size='small' variant='text' onClick={() => {
                    window.location.href = '/extracciones/busqueda';
                }}>
                    Buscar datos
                </Button>
                {
                    ExportButton()
                }
            </Stack>
        )

    }
}